<template>
    <div id="app" class="app fond">
        <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>

                <section class="Section-pages">
                    <section v-for="aide in listeAidesFinancieres" :key="aide.id">
                        <div class="">
                            <div class="Infos Contact">
                                <h4>{{aide.titre}}</h4>
                                <a :href="aide.lien">{{aide.lien}}</a>
                                <p class="paragraphe" v-html="aide.description"></p>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'AidesFinancieres',
    data () {
        return{
            listeAidesFinancieres: [],
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            }
        }
    }, 

    created(){
        axios.get(param.host+'aideFinanciere/v1/listeAidesFinancieres')
        .then(response =>{
            this.listeAidesFinancieres = response.data

            let type = new Array
            let k = 0

            for(let i = 0; this.listeAidesFinancieres.length > i; i++){
                if(i === 0){
                    type[k] = this.listeAidesFinancieres[i].type
                    k++;
                }else{
                    
                }
            }
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Aides financières'){
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))
    },

}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Aides-Financieres.vue